import { motion } from "framer-motion";

const TsundereDoge = ({ duration = 1, delay = 0}) => {
    const variants = {
        opacity: [0, 1],
        transition: {
            duration,
            delay,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut"
        }
    };

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
        >
            <path
                fill="#F29555"
                d="M455.7,168.6c15.5-50.7,13.7-104.3,10.6-135.6c-1.3-13.5-13.3-23.3-26.7-22c-1.2,0.1-2.5,0.3-3.7,0.7
            c-60.5,15.6-96.3,41.8-116.6,62.7c-20.8-4.8-42-7.1-63.4-7c-21.3-0.1-42.6,2.2-63.4,7c-20.2-20.9-56.1-47.1-116.6-62.7
            C63,8.2,49.7,16.1,46.3,29.2c-0.3,1.2-0.5,2.5-0.7,3.7c-3.1,31.3-4.8,84.9,10.6,135.6C25.7,214.5,11,285.3,11,339.5
            C11,388,91.8,501,256,501s245-113,245-161.5C501,285.3,486.3,214.5,455.7,168.6L455.7,168.6z"
            />
            <path
                fill="#F7E3CD"
                d="M384.5,302.6c-50.7,0-72.5,50.1-128.5,50.1s-77.8-50.1-128.5-50.1c-73.5,0-104.7,61.8-108.2,69.3
            C43.7,425.9,122.2,501,256,501s212.3-75.1,236.7-129.1C489.2,364.4,458,302.6,384.5,302.6z"
            />
            <path
                fill="#F2C59E"
                d="M255,463.7c-110.9,0-189.2-44.2-235.4-92.4l-0.3,0.6C43.7,425.9,122.2,501,256,501s212.3-75.1,236.7-129.1
            c-0.2-0.5-0.5-1.1-1-2C445.6,418.6,366.9,463.7,255,463.7z"
            />
            <g>
                <path
                    fill="#F7E3CD"
                    d="M126,97.7c-12.6-13.3-32.2-33.4-39.7-38.3c-30-19.8-42.6,6-42.6,6c-0.7,28.8,1.5,64.7,11.5,99.5
                c31.5-31.3,85.7-59,85.7-59C135.2,104.7,130,101.9,126,97.7L126,97.7z"
                />
                <path
                    fill="#F7E3CD"
                    d="M386,97.7c12.6-13.3,32.2-33.4,39.7-38.3c30-19.8,42.6,6,42.6,6c0.6,28.8-1.5,64.7-11.5,99.5
                c-31.5-31.3-85.7-59-85.7-59C376.8,104.7,382,101.9,386,97.7z"
                />
                <path
                    fill="#F7E3CD"
                    d="M207.7,196.6c0,10.3-10.3,18.7-23.1,18.7s-23.1-12.4-23.1-22.7s10.3-14.7,23.1-14.7
                S207.7,186.3,207.7,196.6L207.7,196.6z"
                />
                <path
                    fill="#F7E3CD"
                    d="M305.8,196.6c0,10.3,10.3,18.7,23.1,18.7s23.1-12.4,23.1-22.7s-10.3-14.7-23.1-14.7
                S305.8,186.3,305.8,196.6z"
                />
            </g>
            <path
                d="M467.4,166.8c14.2-49.7,13.2-100.9,9.7-135.5c-1.9-19-18.8-32.9-37.9-31.1c-1.8,0.2-3.5,0.5-5.2,0.9
            c-60,15.5-96.7,41.3-117.7,61.6c-39.9-8.1-81-8.1-120.8,0c-21-20.3-57.7-46.2-117.7-61.6C59.4-3.7,40.5,7.5,35.7,26
            c-0.4,1.7-0.7,3.5-0.9,5.2c-3.4,34.7-4.4,85.9,9.7,135.5C11.7,218.8,0,292.1,0,339.9c0,26.1,20,69.3,64.8,106.9
            C100,476.6,161.9,512,256,512s156-35.4,191.2-65.1C492,409.2,512,366,512,339.9C512,292.1,500.3,218.8,467.4,166.8L467.4,166.8z
             M439.1,20.5c4.1-1.1,8.4-0.3,11.9,2.2c3.5,2.4,5.7,6.3,6.2,10.5c0.3,2.9,0.6,6.2,0.8,9.7c-0.6-0.2-1.2-0.4-1.8-0.6
            c-10.9-3-22.8-0.3-35.4,8c-6.5,4.3-20.5,17.7-41.6,40c-4.9,5.2-12.5,6.9-19.2,4.3c-9.2-3.6-20.7-9.7-27.7-19.2
            C351.7,57.1,385,34.5,439.1,20.5z M61,22.7c2.4-1.7,5.3-2.6,8.2-2.6c1.2,0,2.5,0.2,3.7,0.5c54.1,13.9,87.4,36.6,106.8,54.8
            c-7,9.5-18.6,15.6-27.7,19.2c-6.7,2.6-14.3,0.9-19.2-4.3c-21.1-22.2-35.1-35.7-41.6-40c-12.5-8.3-24.4-11-35.4-8
            c-0.6,0.2-1.2,0.4-1.8,0.6c0.3-3.5,0.5-6.8,0.8-9.7C55.2,29,57.5,25.1,61,22.7z M434.3,431.5c-32.7,27.6-90.2,60.4-178.3,60.4
            s-145.6-32.9-178.3-60.4c-37.8-31.9-57.6-70.2-57.6-91.6c0-49.8,13.5-120.3,43.5-165.6c7.1-8.4,15.1-16,23.8-22.8
            c4.4-3.3,5.3-9.6,2-14c-3.3-4.4-9.6-5.3-14-2c-5.2,3.9-10.1,8.2-14.8,12.8c-6.5-28.5-8-57.1-7.7-80.5c2-2.9,4.9-5,8.3-6
            c5.1-1.3,11.5,0.5,19,5.4c5,3.3,19.2,17.1,38.1,37c10.5,11.2,26.8,14.8,41.1,9.2c13.2-5.2,30.2-14.6,39.7-30.8
            c37.6-7.8,76.3-7.8,113.9,0c9.5,16.1,26.5,25.6,39.7,30.8c14.3,5.7,30.6,2,41.1-9.2c18.9-19.9,33.2-33.7,38.1-37
            c7.5-4.9,13.9-6.7,19-5.4c3.4,1,6.3,3.1,8.3,6c0.4,23.4-1.2,52-7.7,80.5c-4.7-4.6-9.6-8.8-14.8-12.8c-4.4-3.3-10.7-2.4-14,2
            c-3.3,4.4-2.4,10.7,2,14.1c8.7,6.7,16.7,14.4,23.8,22.8c30.1,45.4,43.5,115.8,43.5,165.6C491.9,361.3,472.1,399.6,434.3,431.5z"
            />
            <path
                d="M332.6,389.3h-65.8v-17.7c9.9-2.1,19-6.9,26.4-13.8c9.7-9,15.5-20.4,15.5-30.6c0-20.6-22.8-36.8-51.9-36.8
            s-51.9,16.1-51.9,36.8c0,18.1,18,39.5,41.9,44.4v17.7h-66.1c-5.5,0-10,4.5-10,10s4.5,10,10,10h151.9c5.5,0,10-4.5,10-10
            S338.1,389.3,332.6,389.3L332.6,389.3z"
            />
            <path
                d="M186.7,252.5c5.5,0,10-4.5,10-10s-4.5-10-10-10h-61c-5.5,0-10,4.5-10,10c0,13.9,11.2,25.1,25.1,25.1c10,0,19-5.9,23-15.1
            H186.7z"
            />
            <path
                d="M384,232.5h-60.9c-5.5,0-10,4.5-10,10c0,13.9,11.2,25.1,25.1,25.1c10,0,19-5.9,23-15.1H384c5.5,0,10-4.5,10-10
            S389.5,232.5,384,232.5z"
            />
            <motion.path
                animate={{ opacity: [0, 1] }}
                transition={variants.transition}
                fill="#AA0C18"
                d="M120.1,338.2l-9-21.8l-14.4,14.4c-4.5,4.5-11.8,4.5-16.3,0l0,0c-4.5-4.5-4.5-11.8,0-16.3L107,288
            c5.8-5.8,15.6-3.8,18.8,3.7l8.5,20.6l25.3-28.9c4.2-4.8,11.4-5.3,16.2-1.1h0c4.8,4.2,5.3,11.4,1.1,16.2l-37.5,42.9
            C133.8,347.8,123.4,346,120.1,338.2z"
            />
            <motion.path
                animate={{ opacity: [0, 1] }}
                transition={variants.transition}
                fill="#AA0C18"
                d="M391.9,342.8l9-21.8l14.4,14.4c4.5,4.5,11.8,4.5,16.3,0h0c4.5-4.5,4.5-11.8,0-16.3L405,292.6
            c-5.8-5.8-15.6-3.8-18.8,3.7l-8.5,20.6l-25.3-28.9c-4.2-4.8-11.4-5.3-16.2-1.1v0c-4.8,4.2-5.3,11.4-1.1,16.2l37.5,42.9
            C378.2,352.3,388.6,350.6,391.9,342.8z"
            />
        </svg>
    );
};

export default TsundereDoge;
